module.exports = __webpack_public_path__ + "img/背抠兔子.9f740420.gif";